<template>
    <div class="main" style="padding-bottom:50px">
        <div @click="redirectPreviousUrl"
            style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
            <p>
                <a-icon type="double-left" />
            </p>
            <p>Go Back </p>

        </div>
        <div style="display:flex;justify-content: space-between;">
            <div style="display:flex;justify-content: space-between;">
                <p>Status: </p>
                <div class="ml-4">
                    <status-component :status="statusLabel"></status-component>
                </div>
            </div>
            <div style="display:flex;justify-content: flex-end;">
                <!-- <a-button v-if="showEmailActions(statusLabel)"  style="border-raduis:5px; background: #418a49; color:#fff;margin-right:20px"> Send Via Mail <a-icon type="mail" /> </a-button> -->
                <!-- <a-button @click="editPurchaseOrder" style="border-raduis:5px; background: #418a49; color:#fff;margin-right:20px"> Edit <a-icon type="edit" /> </a-button> -->
                <a-button v-if="showEditActions(statusLabel)" @click="editPurchaseOrder"
                    style="border-raduis:5px; background: #418a49; color:#fff;margin-right:20px"> Edit <a-icon
                        type="edit" /> </a-button>
                <a-button @click="downloadReceipt" style="border-raduis:5px; background: #418a49; color:#fff;"> Download
                    <a-icon type="download" /> </a-button>
            </div>

        </div>
        <div id="printMe" style="margin-top:50px;background:#fff; padding:30px;">
            <div class="container">
                <!-- Content here -->
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <!-- <div style="background-color:#ccc;;width: 70px; height: 37px;margin-top:5px;"></div> -->
                            </div>
                            <div class="col">
                                <!-- <span style="font-size:20px; font-weight:bolder">{{supplierDetails.name}}</span>
                                <span style="font-size:13px;display:block">{{supplierDetails.address}}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div style="float:right">
                            <span style="font-size:20px; font-weight:bolder">PURCHASE ORDER</span>
                            <span style="font-size:16px;display:block">DATE: {{ currentDate }}</span>
                            <span style="font-size:16px;display:block">{{ getPurchaseOrderIder }}</span>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-md-center mt-3">
                    <div class="col">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <div class="row">
                                <div class="col-4" style="font-weight:bolder;font-size:18px;">
                                    Supplier:
                                </div>
                                <div class="col-8">
                                    <span style="font-weight:bolder;font-size:16px;">
                                        {{ supplierName }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierAddress }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierCity }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierCountry }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <div class="row">
                                <div class="col-4" style="font-weight:bolder;font-size:18px;">
                                    Ship To:
                                </div>
                                <div class="col-8">
                                    <span style="font-weight:bolder;font-size:16px;">
                                        {{ destionationName }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ sellerAddress }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipCity }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipCountry }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top:30px;display: flex; justify-content: space-between">
                    <div class="col">
                        <div style="font-weight:bolder">Shipping Method</div>
                        <div style="padding-left: 38px;padding-right: 38px;">{{ shippingMethodLabel }}</div>
                    </div>

                    <div class="col" style="text-align: end;" :span="12">
                        <div style="font-weight:bolder">Delivery Date</div>
                        <div style="">
                            {{ deliveryDate }}
                        </div>
                    </div>
                </div>
                <div style="margin-top:30px">
                    <p>Purchase Orders </p>
                    <table class="table table-striped table-hover table-bordered">

                        <thead>
                            <tr>
                                <th scope="col">Product Name</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">UnitPrice</th>
                                <th scope="col">Line Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in tableData" :key="product.id">
                                <td>{{ product.name }}</td>
                                <td>{{ product.quantity }}</td>
                                <td>{{ product.unitPrice }}</td>
                                <td>{{ product.lineTotal }}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div style="margin-top:40px">
                    <div class="row">
                        <div class="col">
                            <p style="font-weight:bolder">Terms:</p>
                            <p>{{ shippinTerm }}</p>
                        </div>
                        <div class="col">
                            <div class="row" style="display:flex;justify-content: flex-end;">
                                <div class="col" style="font-weight:bolder;font-size: 19px;" :span="8">Sub Total: </div>
                                <div class="col" :span="12" style="font-size: 19px;">Ksh {{
            displayTotalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</div>
                            </div>
                            <div class="row" style="display:flex;justify-content: flex-end;">
                                <div class="col" style="font-weight:bolder;font-size: 19px;" :span="8">Discount: </div>
                                <div class="col" style="display:flex; height:20px;font-size: 19px;" :span="12">
                                    - {{ discount }}
                                </div>
                            </div>
                            <div class="col" style="display:flex;justify-content: flex-end;padding-top:30px">
                                <div class="col-8" style="font-weight:bolder;font-size: 25px;">Grand Total: </div>
                                <div class="col-6" style="font-weight:bolder;font-size: 25px;">Ksh {{
            displayGrandTotal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a-modal class="modalStyle" :visible="addProductVisible" :footer="null" @cancel="handleAddProductCancel">
                <a-spin :spinning="loading">
                    <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Download
                    </h4>
                    <div>
                        <h5 class="text-center pt-4 pb-4">Are you sure you want to download?</h5>
                        <div style="display:flex;justify-content:center;margin-top:20px">
                            <a-button @click="submitReceipt"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Download
                            </a-button>
                        </div>

                    </div>
                </a-spin>
            </a-modal>
        </div>
        <div style="background:#fff; margin-top:30px; padding: 30px">
            <div>
                <p>Delivery Orders </p>
                <a-table :columns="deliveryColumns" :data-source="deliveriestableData" :loading="tableLoading"
                    :pagination="pagination" class="orderTable">

                    <!-- <template slot="thumb" slot-scope="">
                            <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
                        </template> -->
                    <template slot="action" slot-scope="data">
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a @click="showDeliveryLines(data)">View More?</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import StatusComponent from '../../shared-components/StatusComponent.vue'
import { IsJsonString } from '@/utils/index'

const columns = [
    {
        title: 'Product Name',
        dataIndex: 'name',
        key: "name",
        // scopedSlots: { customRender: 'name' },
        width: 200,
    },
    // {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     // scopedSlots: { customRender: 'category' },
    //     key:"category",
    // 	width: 200,
    // },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity",
        // scopedSlots: { customRender: 'quantity' },
        // width: 200,
    },
    {
        title: 'Selling Price',
        dataIndex: 'unitPrice',
        key: "unitPrice",
        // scopedSlots: { customRender: 'unitPrice' },
        // width: 200,
    },
    {
        title: 'Line Total',
        dataIndex: 'lineTotal',
        key: "lineTotal"
        // width: 200,
    },

]

const deliveryColumns = [
    {
        title: "Delivery ID",
        dataIndex: "id",
        key: "id",
    },
    {
        title: "Received By",
        dataIndex: "receivedBy",
        key: "receivedBy",
    },
    {
        title: "Product Count",
        dataIndex: "productCount",
        key: "productCount",
    },
    {
        title: "Received At",
        dataIndex: "createdAt",
        key: "createdAt",
    },

    {
        title: "Action",
        dataIndex: "action",
        key: 'action',
        scopedSlots: { customRender: "action" },
    },
]

// const data = [
//     {
//         id:1,
//         key:1,
//         name: "VTP Vaccines 1",
//         quantity: 23,
//         unitPrice: 232,
//         lineTotal: 5678
//     },
//     {   
//         id:2,
//         key:2,
//         name: "VTP Vaccines 2",
//         quantity: 23,
//         unitPrice: 232,
//         lineTotal: 5678
//     },
//     {
//         id:3,
//         key:3,
//         name: "VTP Vaccines 3",
//         quantity: 23,
//         unitPrice: 232,
//         lineTotal: 5678
//     }
// ]

export default {
    name: "PurchasedReceipt",
    components: {
        StatusComponent
    },
    data() {
        return {
            columns,
            tableData: [],
            deliveryColumns,
            tableLoading: false,
            loading: false,
            addProductVisible: false,
            discount: 0,
            deliveryDate: null,
            supplierId: "",
            supplierName: "",
            supplierAddress: "",
            supplierCity: "",
            supplierCountry: "",
            destionation: "",
            destionationName: "",
            sellerAddress: "",
            shipCity: "",
            statusLabel: "",
            shipCountry: "",
            shippingMethod: "0",
            shippinTerm: "",
            purchaseOrderId: "",
            deliveriestableData: [],
            pagination: {
                pageSize: 20
            },
        };
    },
    computed: {
        ...mapGetters(['getPreViewInfo']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.unitPrice && item.quantity) {
                    return parseFloat(item.unitPrice) * item.quantity
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt)

        },
        getPurchaseOrderIder() {
            return this.purchaseOrderId ? `Order #PO-${this.purchaseOrderId}` : ""
        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        },

        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount)
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'generatePurcharseOrder', 'setWareHouseDeliveryLinesInfo']),
        redirectPreviousUrl() {
            this.$router.back()
            // this.$router.push('/purchase-order-history').catch(()=>{});
        },
        handleAddProductCancel() {
            this.addProductVisible = false
        },
        downloadReceipt() {

            this.addProductVisible = true
            // this.$htmlToPaper('printMe');
        },
        editPurchaseOrder() {
            this.$router.push('/purchase-order-edit').catch(() => { });
        },
        showEditActions(statusLabel) {
            const allowedStatus = ['Draft']
            const result = allowedStatus.includes(statusLabel) ? true : false
            return result
        },
        showEmailActions(statusLabel) {
            const allowedStatus = ['Draft']
            const result = allowedStatus.includes(statusLabel) ? true : false
            return result
        },

        showDeliveryLines(data) {
            this.setWareHouseDeliveryLinesInfo(data)
            this.$router.push({
                name: 'warehouse-details-lines',
                params: { locationId: data.id }
            }).catch(() => { })
        },

        submitReceipt() {
            this.$htmlToPaper('printMe');
        },
    },
    created() {
        if (this.getPreViewInfo) {

            let result = JSON.parse(this.getPreViewInfo)

            if (IsJsonString(result.supplierAddress)) {
                const json = JSON.parse(result.supplierAddress)
                this.supplierAddress = json.supplierAddress ? json.supplierAddress : "N/A"
                this.supplierCity = json.supplierCity ? json.supplierCity : "N/A"
                this.supplierCountry = json.supplierCountry ? json.supplierCountry : "N/A"
            } else {
                this.supplierAddress = result.supplierAddress ? result.supplierAddress : "N/A"
                this.supplierCity = "N/A"
                this.supplierCountry = "N/A"
            }

            if (IsJsonString(result.sellerAddress)) {
                const json = JSON.parse(result.sellerAddress)
                this.sellerAddress = json.sellerAddress ? json.sellerAddress : "N/A",
                    this.shipCity = json.shipCity ? json.shipCity : "N/A",
                    this.shipCountry = json.shipCountry ? json.shipCountry : "N/A"
                this.destionation = json.destionation ? json.destionation : "N/A"
                this.destionationName = json.destionationName ? json.destionationName : "N/A"

            } else {
                this.sellerAddress = "N/A"
                this.shipCity = "N/A",
                    this.shipCountry = "N/A"
                this.destionation = "N/A"
                this.destionationName = "N/A"
            }

            this.purchaseOrderId = result.purchaseOrderId
            this.discount = result.discount,
                this.deliveryDate = moment(result.deliveryDate).format("DD-MMM-YYYY"),
                this.supplierId = result.supplierId,
                this.supplierName = result.supplierName,
                this.statusLabel = result.statusLabel
            this.shippingMethod = result.shippingMethod ? result.shippingMethod : "0",
                this.shippingMethodLabel = result.shippingMethodLabel,
                this.shippinTerm = result.shippinTerm,
                this.tableData = result.tableData
            this.deliveriestableData = result.deleiveries.map(order => ({
                key: order.id,
                id: order.id,
                receivedBy: order.receivedBy ? order.receivedBy : 'N/A',
                productCount: order.deliveryLines.length,
                createdAt: moment(order.createdAt).format('DD-MM-YYYY HH:mm:ss'),
                action: order
            }))
        }

    }
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

a {
    text-decoration: none;
}

@media print {
    @page {
        size: landscape
    }
}
</style>